var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { computed, ref, set } from "vue";
import { fetchAllBroadcasts } from "@/api/notifications.broadcast";
import { useUserLocalStorage } from "@/composables/userLocalStorage";
import { mergeObjectListsById } from "@/utils/utils";
export const useBroadcastsStore = defineStore("broadcastsStore", () => {
    const broadcasts = ref([]);
    const loadingBroadcasts = ref(false);
    const dismissedBroadcasts = useUserLocalStorage("dismissed-broadcasts", {});
    const activeBroadcasts = computed(() => {
        return broadcasts.value.filter(isActive);
    });
    function loadBroadcasts() {
        return __awaiter(this, void 0, void 0, function* () {
            loadingBroadcasts.value = true;
            yield fetchAllBroadcasts()
                .then((data) => {
                broadcasts.value = mergeObjectListsById(data, [], "create_time", "desc");
            })
                .finally(() => {
                loadingBroadcasts.value = false;
            });
        });
    }
    function updateBroadcasts(broadcastList) {
        broadcasts.value = mergeObjectListsById(broadcasts.value, broadcastList, "create_time", "desc").filter((b) => !hasExpired(b.expiration_time));
    }
    function dismissBroadcast(broadcast) {
        set(dismissedBroadcasts.value, broadcast.id, { expiration_time: broadcast.expiration_time });
    }
    function hasExpired(expirationTimeStr) {
        if (!expirationTimeStr) {
            return false;
        }
        const expirationTime = new Date(`${expirationTimeStr}Z`);
        const now = new Date();
        return now > expirationTime;
    }
    function isActive(broadcast) {
        return (!dismissedBroadcasts.value[broadcast.id] &&
            !hasExpired(broadcast.expiration_time) &&
            hasBeenPublished(broadcast));
    }
    function hasBeenPublished(broadcast) {
        const publicationTime = new Date(`${broadcast.publication_time}Z`);
        const now = new Date();
        return now >= publicationTime;
    }
    function clearExpiredDismissedBroadcasts() {
        var _a;
        for (const key in dismissedBroadcasts.value) {
            if (hasExpired((_a = dismissedBroadcasts.value[key]) === null || _a === void 0 ? void 0 : _a.expiration_time)) {
                delete dismissedBroadcasts.value[key];
            }
        }
    }
    clearExpiredDismissedBroadcasts();
    return {
        broadcasts,
        dismissedBroadcasts,
        loadingBroadcasts,
        activeBroadcasts,
        dismissBroadcast,
        loadBroadcasts,
        updateBroadcasts,
    };
});
